import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ContactModel, EBusinessType, EContactType} from '../../../@models';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';
import {ApiService} from '../../../@core/service/api.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'ngx-form-contact',
  templateUrl: './form-contact.component.html',
  styleUrls: ['./form-contact.component.scss'],
})

export class FormContactComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: string;
  @Input() value: ContactModel;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() enabled: boolean = true;

  contactName: string;

  contactService: CompleterData;

  private contactSubject = new Subject();
  private contactSubscription: any;

  constructor(private api: ApiService, private completerService: CompleterService) {
    this.contactService = this.completerService.local(
      this.contactSubject,
      'displayTitle',
      'displayTitle')
  }

  ngOnInit() {
    if (this.value != null) {
      this.contactName = this.value.title;
    }
    this.reloadContacts();
    this.contactSubscription = this.api.contactsChanged.subscribe(() => {
      this.reloadContacts();
    });
  }

  ngOnDestroy(): void {
    if (this.contactSubscription != null) this.contactSubscription.unsubscribe();
  }

  private reloadContacts() {
    this.api.reloadContacts({type: EBusinessType.NRK, contactType: EContactType.Employee})
      .subscribe(x => this.contactSubject.next(x));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value != null && changes.value.currentValue != null)
      this.contactName = changes.value.currentValue.title;
  }

  select(item: CompleterItem): void {
    if (item != null)
      this.valueChange.emit(item.originalObject);
  }
}
